import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import FormaPago from './FormaPago';
import ACCESS from '../../../ACCESS.js';

class FormasPago extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'forma-pago/filter', deleteUrl: 'forma-pago/delete', deleteField: 'forma_nombre', modUrl: '/Catalogo/FormaPago' },
      TableOp.Table('Formas de Pago', [
        { label: 'Clave', id: 'forma' },
        { label: 'Descripcion', id: 'forma_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_FORMAS_DE_PAGO.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_FORMAS_DE_PAGO.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <FormaPago  onSave={() => {this.table()}}></FormaPago>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(FormasPago)